import {Component, OnInit} from '@angular/core';
import {Project} from "../../../Models/project";
import {ProjectService} from "../../../Services/project.service";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../Account/Service/auth.service";
import {environment} from 'src/environments/environment';
import {EmailsService} from "../../../Services/emails.service";

@Component({
    selector: 'app-show-all-power-bi',
    templateUrl: './show-all-power-bi.component.html',
    styleUrls: ['./show-all-power-bi.component.scss']
})
export class ShowAllPowerBiComponent implements OnInit {
    emailsData: any[] = [];

    constructor(private emailServ: EmailsService, private toastr: ToastrService, private authService: AuthService) {
    }

    ngOnInit(): void {
        this.emailServ.getAllEmails().subscribe(emails => {
            if (emails.length>0)
               return this.emailsData = emails;
            if (emails.length==0)
                return  this.toastr.error( "Sorry.... You haven't data to access it","No Data" )
        });
    }

    protected readonly environment = environment;
}
